import { Checkbox, Grid, Stack } from "@mui/material";
import { Truck } from "../../../domain/model/Truck";
import { CustomTextView } from "../../component/CustomTextView";
import { CustomCardView } from "../../component/CustomCardView";
import {
  COLOR_MAIN,
  COLOR_VERY_LIGHT_GRAY,
  COLOR_WHITE,
} from "../../../data/colors/Colors";

export function TrucksListItemView({
  truck,
  index,
  onChecked,
}: {
  truck: Truck;
  index: number;
  onChecked: (checked: boolean, id: string) => void;
}) {
  return (
    <CustomCardView
      padding={2}
      borderRadius={4}
      background={COLOR_MAIN}
      children={
        <Grid container spacing={1}>
          <Grid>
            <Stack direction={"row"} alignItems={"center"}>
              <CustomTextView
                text={`#${index + 1}`}
                textColor={COLOR_WHITE}
                variant="h5"
                fontWeight="bold"
              />
              <Checkbox
                checked={truck.selected == undefined || truck.selected == true}
                size="large"
                color="success"
                onChange={(_, checked) => {
                  onChecked(checked, truck._id);
                }}
              />
            </Stack>
          </Grid>
          <ItemView title={"Name"} subtitle={truck.Truck} />
          <ItemView title={"Direction"} subtitle={truck.Direction} />
          <ItemView title={"Operator ID"} subtitle={truck.OperatorID} />
          <ItemView title={"Vehicle Type"} subtitle={truck.VehicleType} />
          <ItemView title={"Date Started"} subtitle={truck.DateStarted} />
          <ItemView title={"Date Terminated"} subtitle={truck.DateTerminated} />
          <ItemView title={"Report"} subtitle={truck.Report} />
          <ItemView title={"IP Address"} subtitle={truck.IP_Address} />
          <ItemView title={"Longitude"} subtitle={truck.Longitude} />
          <ItemView title={"Latitude"} subtitle={truck.Latitude} />
          <ItemView title={"Velocity"} subtitle={truck.Velocity} />
          <ItemView title={"TotalDistance"} subtitle={truck.TotalDistance} />
          <ItemView title={"Hour"} subtitle={truck.Hour} />
          <ItemView title={"Minute"} subtitle={truck.Minute} />
          <ItemView title={"Second"} subtitle={truck.Second} />
          <ItemView title={"Date"} subtitle={truck.Date} />
        </Grid>
      }
    />
  );
}

function ItemView({ title, subtitle }: { title: string; subtitle: string }) {
  return (
    <Grid>
      <CustomCardView
        padding={1}
        borderRadius={4}
        background={COLOR_VERY_LIGHT_GRAY}
        children={
          <Stack>
            <CustomTextView text={title} variant="caption" />
            <CustomTextView
              text={subtitle}
              variant="subtitle2"
              fontWeight="bold"
              textColor={COLOR_MAIN}
            />
          </Stack>
        }
      />
    </Grid>
  );
}
